<template>
  <AltPage>
    <NotFoundModal />
  </AltPage>
</template>
<script setup>
import AltPage from "@/components/page/AltPage.vue";
import NotFoundModal from "@/components/not-found/NotFoundModal.vue";
</script>
